import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css'; 
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 

$(function () {
    // Resize swiper..
    $('.contentcarousel .swiper').css('width', $('.grid-container').outerWidth() + 'px');
    
    $('.contentcarousel .swiper').each(function (tc, i) {
        const $this = $(this);
        new Swiper(this, {
            modules: [Navigation, Pagination, Autoplay],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination'
            },
            direction: 'horizontal',
            loop: $this.data('loop') == 'True',
            autoplay: $this.data('autoplay') == 'True',
            delay: $this.data('delay'),
            speed: $this.data('speed'),
            stopOnLastSlide: $this.data('loop') == 'False',  // This doesn't seem to have any effect :(
            slidesPerView: 1,
            spaceBetween: 8,
            breakpoints: {
                799: {
                    slidesPerView: 1,
                    spaceBetween: 24
                }
            }
        });
    });
});
